import { Select, SelectProps } from "@componentLibraryWrapper/select";
import { FormControl } from "@componentLibraryWrapper/formControl";
import { InputLabel } from "@componentLibraryWrapper/inputLabel";
import { appendClassName } from "@componentLibraryWrapper/common";
import './selectWithLabel.scss';

export interface SelectWithLabelProps extends SelectProps {
	fullWidth?: boolean,
	label: string,
	labelId: string
}

const SelectWithLabel = (
	{
		className,
		fullWidth=false,
		label,
		labelId,
		...rest 
	}: SelectWithLabelProps) => {

	return (
			<div
				className={appendClassName('sm-selectwithlabel', className)}>
				<FormControl
					fullWidth={fullWidth}>
					<InputLabel
						id={labelId}>
						{label}
					</InputLabel>
					<Select
						{...rest}
						fullWidth={fullWidth}
						label={label}
						labelId={labelId}/>
				</FormControl>
			</div>
	)
}

export default SelectWithLabel;